<script>
  // const BASE_URL = "http://ystqc.e-gap.net/";
  // const BASE_URL = "http://localhost:12136"
  const BASE_URL = "http://srm.ryytngroup.com:9083/"; //正式库地址
  // const BASE_URL = "http://4iw0sl944596.vicp.fun/"; //窦工地址
  // const BASE_URL = "http://srm-test.ryytngroup.com"; //测试库地址
  const bxios_URL = "http://milk.ryytngroup.com/"; //后台打印模板
  // const bxios_URL = "http://47.98.176.225/"; //测试库打印模板暂时不能用
  var bxiorder = "http://srm.ryytngroup.com/"; //正式库订单回执单预览地址
  // var bxiorder = "http://47.98.176.225/"; //测试库订单回执单预览地址
  var bxiosdow = "http://srm-test.ryytngroup.com/";
  if (BASE_URL == "http://srm.ryytngroup.com:9083/") {
    bxiosdow = "http://srm.ryytngroup.com:9083/"; //下载文件地址
  }

  // const BASE_URL = "http://localhost:63735";
  // const bxios_URL = "http://server.wfjksmart.com/";
  export default {
    BASE_URL,
    bxios_URL,
    bxiosdow,
    bxiorder,
  };
</script>